module.exports = __webpack_public_path__ + "img/technology-12.5d64bc8d.png";